import {
  AllProvidersModal,
  getBrandsOverview,
  getGroupByType,
  GetLocationsOverviewParams,
  GroupByType,
  OrdersOverviewEntity,
  PeriodType,
  ChartsFilter,
  OrdersCharts,
  getTimeZone,
  reportError,
} from '@vgrubs/components';
import { DateTime } from 'luxon';
import { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { AllProvidersModalComponent } from '../../../../../components/src/shared/dashboard/AllProvidersModalComponent';

export const BrandAnalyticsSection = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [loadingOverview, setLoadingOverview] = useState(false);
  const [overview, setOverview] = useState<OrdersOverviewEntity | null>(null);

  const [allProvidersModal, setAllProvidersModal] =
    useState<AllProvidersModal | null>(null);
  const { id } = useParams() as { id: string };
  const from =
    searchParams.get('from') || DateTime.now().startOf('month').toISODate();
  const to =
    searchParams.get('to') || DateTime.now().startOf('day').toISODate();
  const groupByType = getGroupByType(from, to);

  async function getOverview(groupByType: GroupByType) {
    try {
      setLoadingOverview(true);

      const params: GetLocationsOverviewParams = {
        periodType: PeriodType.CUSTOM,
        groupByType,
        from: DateTime.fromISO(from).startOf('day').toISODate() || '',
        to: DateTime.fromISO(to).endOf('day').toISODate() || '',
        timeZone: getTimeZone,
      };

      const { data: overview } = await getBrandsOverview(id, params);

      setOverview(overview.data);
    } catch (error) {
      reportError(error);
    } finally {
      setLoadingOverview(false);
    }
  }

  useEffect(() => {
    getOverview(groupByType);
  }, [from, to]);
  return (
    <>
      <ChartsFilter from={from} to={to} setSearchParams={setSearchParams} />
      <OrdersCharts
        data={overview}
        loading={loadingOverview}
        setAllProvidersModal={setAllProvidersModal}
        groupByType={groupByType}
      />
      <AllProvidersModalComponent
        allProvidersModal={allProvidersModal}
        setAllProvidersModal={setAllProvidersModal}
      />
    </>
  );
};
